import React, { useState } from 'react';
import cn from 'classnames';
import style from './form.mod.scss';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Input from './input';
import Submit from './submit';
import Textarea from './textarea';
import Container from '../layout/container/container';
import Heading from '../heading/heading';
import Text from '../text/text';
import { GatsbyImage } from 'gatsby-plugin-image';
import Checkbox from './checkbox';
import SliderInput from './slider';
import Spacing from '../layout/spacing/spacing';

const Form = ({ heading, text, hideBorder }) => {
  const classes = cn(style.form, {
    [style[`form--hide-border`]]: hideBorder,
  });
  const [submitStatus, setSubmitStatus] = useState('Send');
  const [submitted, setSubmitted] = useState(false); // New state variable
  const formik = useFormik({
    validateOnChange: false,
    validateOnBlur: true,
    initialValues: {
      name: '',
      email: '',
      phone: '',
      enquiry: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Name is required'),
      email: Yup.string().email('Invalid email').required('Email is required'),
      phone: Yup.string(),
      enquiry: Yup.string().required('Enquiry message is required'),
    }),
    onSubmit: async (values) => {
      setSubmitStatus('Processing...');
      try {
        const response = await fetch(
          'https://hook.us1.make.com/kq31t4e6q2vqmp1rtmvsq632ld1g58g8',
          {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
              Accept: 'application/json',
              'Cache-Control': 'no-cache',
              'Content-Type': 'application/json',
            },
          }
        );

        if (response.ok) {
          setSubmitStatus('Message Sent');
          setSubmitted(true); // Update the submitted state
        } else {
          setSubmitStatus('An error occurred');
          // handle error here
        }
      } catch (error) {
        setSubmitStatus('An error occurred');
        // handle error here
      }
    },
  });

  if (submitted) {
    // window.dataLayer.push({
    //   event: 'contact-form-submit',
    //   formId: 'contact-form',
    // });

    return (
      <Container width="sm" pb={3}>
        <div className={style.thankyou}>
          <div>Thank you for your enquiry, we will be in touch soon!</div>
        </div>
      </Container>
    );
  }

  return (
    <Container size="xl">
      <div className={classes} id="enquiry">
        <div className={style.form__wrapper}>
          <div className={style.form__content}>
            <Spacing mb={`1`} />
            <Text size={'xl'} tag={3} dark text={"Or call us on +64 27 910 7526"}  />
          </div>
          <form onSubmit={formik.handleSubmit} id="contact-form">
            <Input
              type={'text'}
              name={'name'}
              label={'Name'}
              placeholder={'Name *'}
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.errors.name}
            />
            <Input
              type={'email'}
              name={'email'}
              label={'Email'}
              placeholder={'Email *'}
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.errors.email}
            />
            <Input
              type={'text'}
              name={'phone'}
              label={'Phone'}
              placeholder={'Phone'}
              value={formik.values.phone}
              onChange={formik.handleChange}
              error={formik.errors.phone}
            />

            <Textarea
              onChange={formik.handleChange}
              name={'enquiry'}
              label={'Enquiry'}
              placeholder={'Your message *'}
              values={formik.values.enquiry}
              error={formik.errors.enquiry}
            />
            <Submit text={submitStatus} />
          </form>
        </div>
      </div>
    </Container>
  );
};

export default Form;
